<nav style="display: flex; flex-direction: row; gap: 8px">
  <div *ngFor="let page of this.pages" >
    <button mat-stroked-button (click)="loadPage(page.name)" [ngClass]="this.currentPage.name == page.name ? 'nav-button active' : 'nav-button'" >{{page.label}}</button>
  </div>
</nav>
